import { Badge, Button, Icon, NameAvatar, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Row } from '@hero/components/atoms';
import { SidebarAccountSkeleton } from '@hero/components/skeletons';
import { ORGANIZATION_ROLES } from '@hero/constants';
import { useSelectedOrganization } from '@hero/hooks';
import { useGetUser } from '@hero/services/organization-service/hooks';
import { getName, logoutAndRedirect } from '@hero/utils';

import * as S from './style';

const SidebarAccount = ({ isOpen }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: user, isLoading: isUserLoading } = useGetUser();
  const organization = useSelectedOrganization();

  const fullName = getName({ firstName: user?.firstName, lastName: user?.lastName });

  return (
    <S.SideBarAccount
      onClick={() => {
        navigate('/settings');
      }}
    >
      {isUserLoading ? <SidebarAccountSkeleton /> : <NameAvatar name={fullName} />}

      {isOpen && (
        <S.SideBarAccountOpenMenu>
          <Typography variant="caption1Bold" color="fg-inverse">
            {fullName}
          </Typography>
          <Typography variant="caption1">{organization?.name}</Typography>
        </S.SideBarAccountOpenMenu>
      )}

      <S.SideBarAccountContent
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <S.SidebarAccountContentBody>
          <Row gap="6px">
            {!isUserLoading && <NameAvatar size={44} name={fullName} />}
            <Row gap="8px">
              <S.AccountNameContentWrapper>
                <Typography color="fg" variant="caption1Bold">
                  {user?.firstName}
                </Typography>
                <Typography color="fg" emphasis="weaker" variant="caption1">
                  {organization?.name}
                </Typography>
              </S.AccountNameContentWrapper>

              {!!organization?.role && (
                <Badge color="bgDefault" variant="contained" size="sm" rounded>
                  {ORGANIZATION_ROLES[organization?.role]}
                </Badge>
              )}
            </Row>
          </Row>

          <S.AccountButtonWrapper>
            <Button
              onClick={() => {
                navigate('/settings');
              }}
              variant="link"
              color="neutral"
              startIcon={<Icon name="settings" size="md" />}
            >
              {t('settings')}
            </Button>
            <S.AccountButtonLine />
            <Button
              onClick={logoutAndRedirect}
              variant="link"
              color="error"
              startIcon={<Icon name="upload" size="md" />}
            >
              {t('logout')}
            </Button>
          </S.AccountButtonWrapper>
        </S.SidebarAccountContentBody>
      </S.SideBarAccountContent>
    </S.SideBarAccount>
  );
};

SidebarAccount.propTypes = {
  isOpen: PropTypes.bool
};

export default SidebarAccount;
